export default "__VITE_ASSET__DPOLyaxu__"